"use client"

import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

const Select = ({ 
  value, 
  onValueChange, 
  options, 
  className,
  theme = 'dark',
  placeholder = 'Select option...'
}) => {
  return (
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className={cn(
          'block w-full rounded-md border py-2 pl-3 pr-10 text-sm appearance-none',
          'focus:outline-none focus:ring-2 focus:ring-indigo-500',
          theme === 'light' 
            ? 'border-gray-200 bg-white text-gray-900'
            : 'border-gray-700 bg-gray-800 text-gray-100',
          className
        )}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map((option) => (
          <option 
            key={option.value} 
            value={option.value}
            className={theme === 'dark' ? 'bg-gray-800' : undefined}
          >
            {option.label}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
        <ChevronDown className={cn(
          "h-4 w-4",
          theme === 'light' ? "text-gray-400" : "text-gray-500"
        )} />
      </div>
    </div>
  );
};

export { Select }; 